(() => {
  if (window.CCCartMeasurement) return;
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
  }
  const storageKey = 'cc_ga4_pending_cart_v1';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const clear = () => { try { sessionStorage.removeItem(storageKey); } catch {} };
  const readCart = async (root, timeout) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw Error('cart-read');
      return await response.json();
    } finally { clearTimeout(timer); }
  };
  const linesFor = (cart, designKey, id) => cart.items.filter(line =>
    String(line.variant_id) === id && line.properties?._Ontwerpcode === designKey);
  const quantityOf = lines => lines.reduce((sum, line) => sum + line.quantity, 0);
  const prepare = async ({ designKey, items, root }) => {
    clear();
    if (!allowed()) return;
    try {
      const cart = await readCart(root, 800);
      if (!allowed()) return;
      const requested = new Map();
      for (const item of items) {
        const id = String(item.id), quantity = Number(item.quantity);
        if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return;
        requested.set(id, (requested.get(id) || 0) + quantity);
      }
      const marker = {
        version: 1, created: Date.now(), nonce: crypto.randomUUID(), designKey, root,
        items: [...requested].map(([id, quantity]) => ({
          id, quantity, before: quantityOf(linesFor(cart, designKey, id))
        }))
      };
      sessionStorage.setItem(storageKey, JSON.stringify(marker));
    } catch { clear(); }
  };
  window.CCCartMeasurement = Object.freeze({ prepare, clear });
  const recover = async () => {
    let marker;
    try { marker = JSON.parse(sessionStorage.getItem(storageKey)); } catch { clear(); return; }
    if (!marker) return;
    if (marker.version !== 1 || !Array.isArray(marker.items) || !marker.items.length ||
        Date.now() - marker.created > 120000 || marker.created > Date.now()) { clear(); return; }
    if (location.pathname.replace(/\/$/, '') !== marker.root + 'cart') return;
    let attempts = 0;
    while (!window.Shopify?.customerPrivacy || typeof window.gtag !== 'function') {
      if (++attempts > 40) { clear(); return; }
      await new Promise(resolve => setTimeout(resolve, 250));
    }
    if (!allowed()) { clear(); return; }
    try {
      const cart = await readCart(marker.root, 2000);
      if (cart.cart_level_discount_applications?.length) { clear(); return; }
      const items = [];
      for (const requested of marker.items) {
        const lines = linesFor(cart, marker.designKey, requested.id);
        if (!lines.length || quantityOf(lines) - requested.before !== requested.quantity) { clear(); return; }
        const line = lines[0];
        const price = line.final_line_price / line.quantity / 100;
        if (!Number.isFinite(price) || price < 0 || lines.some(candidate =>
          candidate.final_line_price / candidate.quantity / 100 !== price)) { clear(); return; }
        items.push({
          item_id: 'shopify_ZZ_' + line.product_id + '_' + line.variant_id,
          item_name: line.product_title, item_brand: line.vendor,
          item_category: line.product_type, item_variant: line.variant_title || undefined,
          variant_id: String(line.variant_id), sku: line.sku || undefined,
          price, discount: Math.max(0, Math.round(line.original_price - price * 100) / 100),
          quantity: requested.quantity
        });
      }
      if (!allowed()) { clear(); return; }
      clear();
      window.gtag('event', 'add_to_cart', {
        send_to: 'G-N8ZZRLXWE9', currency: cart.currency,
        value: Math.round(items.reduce((sum, item) => sum + item.price * item.quantity, 0) * 100) / 100,
        items, event_id: 'cc_cart_' + marker.nonce,
        cc_measurement_source: 'editor_cart_net_v1'
      });
    } catch { clear(); }
  };
  void recover();
})();
